import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";
import * as actionTypes from "./actionTypes";
import { notify } from "../../helpers/utility";

export const agentDialStart = () => {
  return {
    type: actionTypes.AGENT_DIAL_START,
  };
};

export const agentDialFail = (error) => {
  return {
    type: actionTypes.AGENT_DIAL_FAIL,
    error: error,
  };
};

export const agentDialSuccess = (agentId) => {
  return {
    type: actionTypes.AGENT_DIAL_SUCCESS,
  };
};

export const agentUniqueDialStart = () => {
  return {
    type: actionTypes.AGENT_DIAL_START,
  };
};

export const agentUniqueDialFail = (error) => {
  return {
    type: actionTypes.AGENT_DIAL_FAIL,
    error: error,
  };
};

export const agentUniqueDialSuccess = (agentId) => {
  return {
    type: actionTypes.AGENT_DIAL_SUCCESS,
  };
};


export const agentDial = (agentId, phone, leadId, listId, callerId, redial, phoneType) => {
  return (dispatch) => {
    dispatch(agentDialStart());
    ctiRequest["CTI_DIAL"].agent_id =agentId;
    ctiRequest["CTI_DIAL"].phone_num = phone;
    ctiRequest["CTI_DIAL"].lead_id = leadId;
    ctiRequest["CTI_DIAL"].list_id = listId;
    ctiRequest["CTI_DIAL"].callerid = callerId;
    ctiRequest["CTI_DIAL"].redialFlag = redial;
    ctiRequest["CTI_DIAL"].phone_type = phoneType;

    window.clientIP = localStorage.getItem("clientIP")
      ? localStorage.getItem("clientIP")
      : "127.0.0.1";
    ctiRequest["CTI_DIAL"].ip = window.clientIP;
    const selectedGateway = localStorage.getItem("selected_gateway");
    if (selectedGateway && selectedGateway !== "default") {
      ctiRequest["CTI_DIAL"].gateway_name = selectedGateway;
    }
    
    axios
      .post("/", ctiRequest["CTI_DIAL"])
      .then((result) => {
        if (result.data.response.status === "SUCCESS") {
          
          dispatch(agentDialSuccess(agentId));
        } else {
          notify("Dial Error: " + result.data.response.reason, "agent-dial");
          dispatch(agentDialFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        notify("Dial Error", "agent-dial");
        dispatch(agentDialFail(err));
      });
  };
};

// Dial with Unique Id

export const agentDialUniqueId = (agentId, phone, leadId, listId, callerId, redial,) => {
    return (dispatch) => {
        dispatch(agentUniqueDialStart());

        const requestBody = {
            ...ctiRequest["CTI_DIAL_THROUGH_UNIQUE_IDCTI_DIAL"],
            agent_id: agentId,
            phone_num: phone,
            list_id: listId,
            lead_id: leadId,
            callerid: callerId,
            redialFlag: redial       
        };

        fetch(window.Configs.ldap_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
        })
        .then((response) => response.json())

        .then((result) => {
            if (
                result.status === "SUCCESS" 
            ) {
                if(result.failure_reason === ""){
                dispatch(agentUniqueDialSuccess(result.data.agentId));
                }
                else{
                   dispatch(agentUniqueDialFail(result.failure_reason));
                    notify("Dial Error: " + result.failure_reason, "agent-dial");
                }
            } else {
                dispatch(agentUniqueDialFail(result.failure_reason));
                notify("Dial Error: " + result.failure_reason, "agent-dial");
            }
        })
        .catch((err) => {
           notify("Dial Error", "agent-dial");
            dispatch(agentUniqueDialFail(err));
        });
    };
};
